<template>
  <vue-treeselect v-model="val"
                  class="hidden"
                  multiple
                  clearable
                  always-open
                  sort-value-by="INDEX"
                  value-consists-of="LEAF_PRIORITY"
                  :noOptionsText="$t('message.generics.message.noOptionsText')"
                  :maxHeight="dataMaxHeight"
                  :default-expand-level="1"
                  :options="operations"></vue-treeselect>
</template>

<script>
import VueTreeselect from "@riophae/vue-treeselect";
import vModel from "@mixins/v-model";

export default {
  components: {
    VueTreeselect,
  },

  props: {
    dataMaxHeight: {
      type: Number,
      default: 305,
    },
    operations: {
      type: Array,
    },
  },

  computed: {
    rawDevices() {
      return this.$store.state.devices.list;
    },
  },

  mixins: [vModel],
};
</script>

<style scoped>
</style>
